import NotificationsController        from "@/js/Webmail/Notifications/NotificationsController";
import WizardHTTPService              from "./HTTP/WizardHTTPService";
import StateEventManager              from "@/js/Shared/Events/Managers/StateEventManager";
import LayoutSettingsController       from "@/js/Webmail/LayoutSettingsController";
import BrowserNotificationsController from "@/js/Webmail/Notifications/BrowserNotificationsController";
import IdentitiesController           from "../Identities/IdentitiesController";


export { WizardController as default };

/**
* Wizard Settings Controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class WizardController {
  /**
   * HTTP Service object
   *
   * @private
   *
   * @type {WizardHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new WizardHTTPService();

  /**
   * Event state
   *
   * @public
   *
   * @type {StateEventManager}
   *
   * @since 7.0.0
   */
  state = new StateEventManager();

  /**
   * Holds configuration values that can be reverted
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  configuration = {};

  /**
   * Saves current configuration so it can be reverted later on if needed
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Boolean}
   */
  saveCurrentConfiguration() {
    this.configuration.theme              = LayoutSettingsController.theme;
    this.configuration.theme_option       = LayoutSettingsController.theme_option;
    this.configuration.theme_orientation  = LayoutSettingsController.theme_orientation;
    this.configuration.color_scheme       = LayoutSettingsController.color_scheme;
    this.configuration.font_size          = LayoutSettingsController.font_size;
    this.configuration.notifications      = BrowserNotificationsController.enabled;
  }

  /**
   * Reverts configuration to the previous saved state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Boolean}
   */
  revertConfiguration() {
    LayoutSettingsController.theme             = this.configuration.theme;
    LayoutSettingsController.theme_option      = this.configuration.theme_option;
    LayoutSettingsController.theme_orientation = this.configuration.theme_orientation;
    LayoutSettingsController.color_scheme      = this.configuration.color_scheme;
    LayoutSettingsController.font_size         = this.configuration.font_size;
    BrowserNotificationsController.setEnabled(this.notifications);
  }

  /**
   * Calls ask later endpoind and processes it's response
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async askLater() {
    this.state.setLoading('submitting')
    let response = await this.http_service.askLater();
    NotificationsController.addMessage('notifications.', response.messages);
    this.state.setSuccess('submitting', response.success);
    return response.success;
  }

  /**
   * Calls finished endpoind and processes it's response
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async finished(identity_name, identity_signature) {
    this.state.setLoading('submitting')

    let identity            = IdentitiesController.identities.getDefault();
    identity.name           = identity_name;
    identity.signature_html = identity_signature;

    if (await IdentitiesController.saveIdentity(identity, false) === false) {
      this.state.setSuccess('submitting', false);
      return false;
    }

    let response = await this.http_service.finished();
    NotificationsController.addMessage('notifications.', response.messages);
    this.state.setSuccess('submitting', response.success);
    return response.success;
  }

  async whatsNew() {
    this.state.setLoading('submitting')
    let response = await this.http_service.whatsNew();
    this.state.setSuccess('submitting', response.success);
    return response.success;
  }

  /**
   * Calls finished endpoind without prcessing notifications
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
    async revert() {
      this.state.setLoading('submitting')
      let response = await this.http_service.finished();
      this.state.setSuccess('submitting', response.success);
      return response.success;
    }
}